import * as React from "react";
import {FormEvent, useRef, useState} from "react";
import iconClose from "../../assets/icons/close.svg";
import iconMagnifier from "../../assets/icons/magnifier.svg";
import {useSearchParams} from "react-router-dom";

interface ISearchForm {
    resetCount: number;
}

export const SearchForm: React.FC<ISearchForm> = ({ resetCount }) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const searchField = useRef<HTMLInputElement>(null);
    const [fieldChanged, setFieldChanged] = useState<boolean>(
        searchParams.get("query") !== ""
    );

    function setParams(query: string) {
        setSearchParams((params) => {
            params.set("query", query);
            params.set("page", "0");
            return params;
        });
    }

    function onSearchQuery(event: FormEvent<HTMLFormElement>) {
        event.preventDefault();
        const val = searchField.current?.value || "";
        setFieldChanged(val !== "");
        setParams(val);
    }

    function clearQuery() {
        if (searchField.current) {
            searchField.current.value = "";
        }
        setFieldChanged(false);
        setParams("");
    }

    React.useEffect(() => {
        if (resetCount > 0) {
            clearQuery();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [resetCount]);

    return (
        <form onSubmit={onSearchQuery} className="mb-4">
            <div className="form-group">
                <label htmlFor="query" className="w-100 font-weight-bold">
                    Part No.
                </label>
                <div className="input-group with-prefix-icon">
                    <input
                        id="query"
                        name="query"
                        className="form-control"
                        type="text"
                        pattern="[A-Za-z0-9\-_.]*"
                        ref={searchField}
                        defaultValue={searchParams.get("query") || ""}
                        placeholder="Search for complete Part No."
                        onChange={(event) =>
                            setFieldChanged(event.currentTarget.value !== "")
                        }
                    />
                    <span className="prefix-icon">
                        <img className="icon" src={iconMagnifier} alt="" />
                    </span>
                    <span className="clear-button" role="button">
                        {fieldChanged && (
                            <img
                                className="icon"
                                src={iconClose}
                                alt=""
                                onClick={clearQuery}
                            />
                        )}
                    </span>
                    <div className="error-message">
                        Please enter a valid Part No.
                    </div>
                </div>
            </div>
        </form>
    );
};
export default SearchForm;
